import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_ITEM_CATEGORY_FAILURE,
  FETCH_ITEM_CATEGORY_REQUEST,
  FETCH_ITEM_CATEGORY_SUCCESS,
  ItemCategoryActionType,
} from '../types/itemCategoryType';

// Action creators
export const fetchItemCategoryRequest = (): ItemCategoryActionType => ({
  type: FETCH_ITEM_CATEGORY_REQUEST,
});

export const fetchItemCategorySuccess = (
  data: any
): ItemCategoryActionType => ({
  type: FETCH_ITEM_CATEGORY_SUCCESS,
  payload: data,
});

export const fetchItemCategoryFailure = (
  error: string
): ItemCategoryActionType => ({
  type: FETCH_ITEM_CATEGORY_FAILURE,
  payload: error,
});

// Async action creator using Thunk
export const fetchItemCategories = () => {
  return async (dispatch: Dispatch<ItemCategoryActionType>) => {
    dispatch(fetchItemCategoryRequest());
    try {
      const request = await Service.get('/categories');
      const data: any[] = request?.data?.data?.categories;
      dispatch(fetchItemCategorySuccess(data));
    } catch (error: any) {
      dispatch(fetchItemCategoryFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch item categories');
    }
  };
};
